import React, { useEffect, useState, useContext } from 'react'
import ListingTableView from '@/product/components/organisms/Template/Product/TableView'
import { Button } from '@mui/material'
import Layout from '@/product/components/templates/Layout'
import DynamicListing from './dynamicListing'
// import ReportContext from '@/product/context/report/reportContext'
import DynamicContext from '@/product/context/dynamic/dynamicContext'
import ListingDynamic from '../../Listing/dynamicListing'
import { useHistory } from 'react-router-dom'
import { handleRedirectInternal } from '@/product/common/components'
import BulkListing from './bulkListing'

const ListingCommon = (props) => {
    const dynamicContext = useContext(DynamicContext)
    const history = useHistory()

    const { project_tablefields } = dynamicContext

    // const { getAllExportDownload } = useContext(ReportContext)

    const [searchInfo, setSearchInfo] = useState({})
    const [tableValue, setTableValue] = useState([])
    const [manage, setManage] = useState({
        popup: false,
        status: 'newTemplate',
        id: 0,
        projectType: 0,
    })
    const [bulkPopup, setBulkPopup] = useState(false)
    const toggleBulkPopup = (popup) => {
        setBulkPopup({ popup })
    }

    const toggleFullScreenPopup = (popup, status, id, projectType) => {
        if (popup && status == 'editTemplate') {
            handleRedirectInternal(
                history,
                `templates/listing/editTemplate/${id}`
            )
        } else if (popup && status == 'use') {
            handleRedirectInternal(history, `listing/use/${id}`)
        }
    }
    let action = props.match.params.action

    const custom = {
        action: {
            value: action
                ? action.toString() !== 'all'
                    ? action.toString()
                    : ''
                : null,
            type: 'in',
            field: 'p.market_status',
        },
    }

    useEffect(() => {
        if (project_tablefields && project_tablefields.length) {
            let dynamicValueAssign = {}
            let searchData = project_tablefields
            dynamicValueAssign.data = searchData
                .filter((item) => item.table_search === 1)
                .map((buscat) => {
                    return Object.assign(buscat, {
                        name: buscat.field,
                        template: 1,
                    })
                })
            setSearchInfo(dynamicValueAssign)
            let dynamicAssign = [...project_tablefields]
            setTableValue(dynamicAssign)
        }
    }, [project_tablefields, action])

    return (
        <>
            <Layout>
                <div className="dashboard listing maillisting">
                    <div className="miscActions d-flex justify-content-start align-items-center flex-wrap mt-4">
                        <Button
                            id="dynamicAuction_add"
                            variant="outlined"
                            className="btnOutlined"
                            onClick={() =>
                                handleRedirectInternal(
                                    history,
                                    `templates/listing/newTemplate/0`
                                )
                            }
                        >
                            <span className="material-icons">note_add</span>Add
                            New Template
                        </Button>
                        <Button
                            id="dynamicAuction_add"
                            variant="outlined"
                            className="btnOutlined"
                            onClick={() => {
                                toggleBulkPopup({
                                    popup: true,
                                    status: 'newTemplate',
                                    id: 0,
                                    projectType: 0,
                                })
                            }}
                        >
                            <span className="material-icons">note_add</span>Add
                            New Bulk Template
                        </Button>
                        {/* <Button
                            id="listingDynamic_report"
                            onClick={() =>
                                getAllExportDownload({
                                    action: 'export',
                                    order: 'asc',
                                    orderby: '',
                                    search: 'all',
                                    report: `${action}_product_management`,
                                })
                            }
                        >
                            <span className="material-icons">get_app</span>Export All Data
                        </Button> */}
                    </div>

                    <ListingTableView
                        searchInfo={searchInfo}
                        customFilter={custom}
                        tableValue={tableValue}
                        toggleFullScreenPopup={toggleFullScreenPopup}
                        tableActionString={
                            global?.templist_tableActionString
                                ? global?.templist_tableActionString
                                : []
                        }
                        listActionString={
                            global?.erp_listAction ? global?.erp_listAction : []
                        }
                        action={action}
                        columnStorageVariable={'table_listing_template'}
                    />
                </div>
                {/* <ListingDynamic
                    data={manage}
                    function={toggleFullScreenPopup}
                /> */}
                {/* <DynamicListing
                    data={manage}
                    function={toggleFullScreenPopup}
                /> */}
                <BulkListing data={bulkPopup} function={toggleBulkPopup} />
            </Layout>
        </>
    )
}

export default ListingCommon
